import { useTranslation } from "react-i18next";
import Container from "react-bootstrap/esm/Container";
import { Globals } from "../globals";

export default function Impressum() {
    const { t } = useTranslation();

    return (
        <Container className="py-4">
            <h1>{t('footer.impressum')}</h1>
            <p className="text-muted">{t('legal.lastUpdated')}: 01.01.2025</p>

            <h2 className="h4 mt-4">{t('legal.impressum.section1Title')}</h2>
            <p>
                Johann Wiebe<br />
                E-Mail: <a href={`mailto:${Globals.ADMIN_EMAIL}`}>{Globals.ADMIN_EMAIL}</a><br />
                Website: <a href={Globals.URL}>{Globals.URL.replace("https://", "")}</a>
            </p>

            <h2 className="h4 mt-4">{t('legal.impressum.section2Title')}</h2>
            <p>{t('legal.impressum.section2Text')}</p>

            <h2 className="h4 mt-4">{t('legal.impressum.section3Title')}</h2>
            <p>{t('legal.impressum.section3Text')}</p>

            <h2 className="h4 mt-4">{t('legal.impressum.section4Title')}</h2>
            <p>{t('legal.impressum.section4Text')}</p>
        </Container>
    );
}
